import createReducer from 'reducers/createReducer';

import { Language } from 'actions/actionTypes';

const INITIAL_STATE = {
    currentLanguage: 'ko-kr',
    supportLanguageList: [
        { code: 'ko-kr', text: '한국어', flag: 'korea' },
        { code: 'en-us', text: 'English', flag: 'united_states' },
        { code: 'zh-cn', text: '简体中文', flag: 'china' },
        { code: 'ja-jp', text: '日本語', flag: 'japanese'},
        { code: 'zh-tw', text: '繁體中文', flag: 'taiwan'},
        // { code: 'vi-vn', text: 'Tiếng Việt' },
    ],

    error: {
        triggered: false,
        message: '',
    },
};

// 리듀서
const reducer = createReducer(INITIAL_STATE, {
    [Language.CHANGE_LANGUAGE]: (state, action) => {
        state.currentLanguage = action.payload;
    },
});

export default reducer;
